import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'

import { gridCancel, gridSave } from 'actions/grid'

import GridHeader from './grid-header'

export class GridHeaderContainer extends Component {

  constructor(props) {
    super(props)

    this.onSave = this.onSave.bind(this)
    this.onCancel = this.onCancel.bind(this)
  }

  onSave() {
    this.props.gridSave(this.props.eventGroupId)
  }

  onCancel() {
    this.props.gridCancel(this.props.eventGroupId)
  }

  render() {
    return (
      <GridHeader {...this.props} onSave={this.onSave} onCancel={this.onCancel} />
    )
  }
}

GridHeaderContainer.propTypes = {
  eventGroupId: PropTypes.number.isRequired,
  gridCancel: PropTypes.func.isRequired,
  gridSave: PropTypes.func.isRequired,
}

const mapDispatchToProps = {
  gridCancel,
  gridSave,
}

export default connect(null, mapDispatchToProps)(GridHeaderContainer)



/** WEBPACK FOOTER **
 ** ./src/components/grid-header/grid-header-container.js
 **/